var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8656 1.19692C11.3781 1.70949 11.3781 2.54051 10.8656 3.05308L3.91866 10L10.8656 16.9469C11.3781 17.4595 11.3781 18.2905 10.8656 18.8031C10.353 19.3156 9.52199 19.3156 9.00942 18.8031L1.13442 10.9281C0.621859 10.4155 0.621859 9.58449 1.13442 9.07192L9.00942 1.19692C9.52199 0.684359 10.353 0.684359 10.8656 1.19692Z",
    fill: "#006DB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.8a5dac802c3ffaba85b184c28f296b97.svg";
export { ForwardRef as ReactComponent };